@if (previewDialog) {
  <div xmlns="http://www.w3.org/1999/html"
       class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full flex justify-center items-center p-4">
        <div class="bg-white px-[32px] rounded-[8px] absolute w-3/5 p-4 2xl:w-2/5">
          <div class="flex justify-between items-center">
            <b>{{previewProblemTemplate.problemtemplate_name}}</b>
            <button (click)="previewDialog = false" class="text-sm rounded-full h-8 w-8 hover:bg-gray-200" aria-label="Close Question Preview">
              <fa-icon [icon]="faXmark" />
            </button>
          </div>
          <div class="overflow-y-auto max-h-[650px]">
            @if (previewProblemTemplate.mathjax) {
              <div [mathjax]="previewProblemTemplate.question_text" class="mb-2"></div>
            }
            @if (!previewProblemTemplate.mathjax) {
              <div [innerHTML]="previewProblemTemplate.question_text" class="my-1"></div>
            }
            @if (previewProblemTemplate.type === 'MULTIPLECHOICE') {
              <multiple-choice [problem_template]="previewProblemTemplate" [review]="true" />
            }
            @if (previewProblemTemplate.type === 'PASSAGE' || previewProblemTemplate.type === 'MULTIFIELD') {
              <multifield [problem_template]="previewProblemTemplate" [review]="true" />
            }
          </div>
        </div>
    </div>
  </div>
}
<breadcrumb endText="Exam Export Config" [navigations]="breadcrumbNavs" />
<div class="m-6 w-auto">
  <h1 class="text-xl mt-6 font-semibold mb-1">
    Exam CSV Export Configuration
  </h1>
  <hr />
  <div class="mt-5 text-zinc-600">
    <p>
      Create custom CSV export by defining column names to include in your export file.
    </p>
  </div>
  <div class="mt-5 flex items-center">
    <b class="mr-2">
      Export Title:
    </b>
    <input [(ngModel)]="reportName" type="text" placeholder="Enter title" class="input"/>
  </div>
  <table *ngFor="let cell of csvColumns; let i = index">
    <tr>
      <th class="font-medium p-1">Column Value</th>
      <th class="font-medium p-1">Column Title</th>
      @if (cell.value.includes('static')) {
        <th class="font-medium p-1">
          Value
        </th>
      }
      <th *ngIf="cell.value.includes('part') || cell.value.includes('question')" class="font-medium p-1">
        Part
      </th>
      <th *ngIf="cell.value.includes('question') && cell.part_selector_value != undefined" class="font-medium p-1">
        Question
      </th>
      <th *ngIf="csvColumns.length > 1 && i != 0"></th>
    </tr>
    <tr>
      <td class="w-72 px-2 py-1">
        <app-sectioned-dropdown [(selectedValue)]="cell.value" [items]="items" (itemSelected)="cell.name = $event.label"></app-sectioned-dropdown>
      </td>
      <td class="px-2 py-1">
        <input [(ngModel)]="cell.name" type="text" class="input" [value]="cell.name" placeholder="Enter Name" />
      </td>
      @if (cell.value.includes('static')) {
        <td class="py-1 px-2">
          <input [(ngModel)]="cell.generic_value" type="text" class="input" placeholder="Enter Value" />
        </td>
      }
      <td *ngIf="cell.value.includes('part') || cell.value.includes('question')" class="py-1 px-2">
        <app-sectioned-dropdown [(selectedValue)]="cell.part_selector_value" [items]="dropdownPartItems" ></app-sectioned-dropdown>
      </td>
      <td *ngIf="cell.value.includes('question') && cell.part_selector_value != undefined" class="py-1 px-2 flex">
        <app-sectioned-dropdown [(selectedValue)]="cell.question_selector_value" [items]="dropdownQuestionItems[Number(cell.part_selector_value)]" ></app-sectioned-dropdown>
        <button class="rounded-[6px] px-3 py-1 hover:bg-gray-200 text-zinc-400 ml-1 text-[14px]" (click)="openPreviewDialog(i)">
          <fa-icon [icon]="faEye" class="ml-1" />
          Preview
        </button>
      </td>
      <td *ngIf="csvColumns.length > 1 && i != 0" class="p-1">
        <button aria-label="Remove Column" (click)="csvColumns.splice(i, 1)" class="text-sm font-medium rounded-full hover:bg-gray-200 p-2 flex items-center gap-2 text-red-700">
          <fa-icon [icon]="faTrash" />
        </button>
      </td>
    </tr>
  </table>
  <div class="mt-3 flex items-center gap-6">
     <button aria-label="Add Column" (click)="csvColumns.push({name: '',value: 'null'})" class="text-sm font-semibold rounded-full hover:bg-gray-200 py-2 px-4 flex items-center gap-2">
      Add New Column <fa-icon [icon]="faAdd" />
    </button>
  </div>
  <div class="flex mt-14 pb-8 justify-end">
    <outline-button [marginRight]="true" (click)="examExportList()" text="cancel" />
    <full-button (click)="saveCSV()" text="save" />
  </div>
</div>
